

























import {
  defineComponent,
  ref,
  computed,
  onMounted,
} from '@nuxtjs/composition-api';

import { useShippingCountryStore } from '~/modules/checkout/stores/shippingCountry';

import { Stripe } from '~/modules/checkout/stripe';

import {
  usePaymentProvider,
  useStripePublicKey,
} from '~/composables';

import type { AvailablePaymentMethod } from '~/modules/GraphQL/types';
import { SkeletonLoader } from '~/components';
import { CustomHeaders } from '~/types/core';

export default defineComponent({
  name: 'StripePaymentProvider',
  components: {
    SkeletonLoader,
    Stripe
  },
  emits: ['stripe-status', 'make-order'],
  setup(_props, { emit }) {
    const {
      load: loadAvailablePaymentMethods,
      save: savePaymentMethodOnCart
    } = usePaymentProvider();

    const { load: loadStripePublicKey } = useStripePublicKey();

    const shippingCountryStore = useShippingCountryStore();

    const paymentMethods = ref<AvailablePaymentMethod[]>([]);
    const selectedPaymentMethodCode = ref<string | null>(null);
    const stripeRef = ref(null);
    const apiKey = ref('');
    const isStripeReady = ref(false);

    const customHeaders = computed<CustomHeaders | {}>(() =>
      shippingCountryStore.shippingCountry.isShippingCountrySpain
        ? { store: 'es' }
        : {}
    );

    const definePaymentMethods = async (paymentMethodCode: string) => {
      paymentMethods.value = await savePaymentMethodOnCart(
        { paymentMethod: { code: paymentMethodCode,
        }},
        customHeaders.value
      );

      selectedPaymentMethodCode.value = paymentMethodCode;
    };

    const triggerStripe = () => {
      if (selectedPaymentMethodCode.value !== 'stripe_payments') return;

      return stripeRef.value.useStripe();
    };

    const handlePaymentStatus = (status) => {
      emit('stripe-status', status);
    };

    const handleIsStripeReady = () => {
      isStripeReady.value = true;
    };

    onMounted(async () => {
      // @ts-ignore
      apiKey.value = await loadStripePublicKey(customHeaders.value);
      paymentMethods.value = await loadAvailablePaymentMethods(undefined, customHeaders.value);
      let stripePaymentMethod = paymentMethods.value.find(method => method.code === 'stripe_payments');
      await definePaymentMethods(stripePaymentMethod?.code);
    });

    return {
      apiKey,
      triggerStripe,
      stripeRef,
      handlePaymentStatus,
      paymentMethods,
      selectedPaymentMethodCode,
      definePaymentMethods,
      handleIsStripeReady,
      isStripeReady
    };
  },
});
